module.exports = __webpack_public_path__ + "media/images/plans/plan-detail-icon-hairmake-men-26960e6dd211a6c9fb4e82f2651eacfd.png";